angular.module('app-ui-profile').directive(
    'appUiProfileUserProfileSearchResults',
    function () {

        var link = function ($scope) {
            $scope.handleResultSelect = function (result) {
                $scope.propOnResultSelect(result, $scope.propSearchId);
            };
        };

        return {
            link: link,
            scope: {
                propSearchId: '=searchId', // Search unique id
                propLoading: '=loading', // bool
                propResults: '=results',
                propOnResultSelect: '=onResultSelect', // function(result)
                propSearchProperties: '=searchProperties', // [{name: '', label: ''}]
            },
            template: '' +
            '<div class="app-ui-search-results" ng-show="propResults.length && !propLoading">' +
            '   <ul class="list-group" ng-repeat="result in propResults">' +
            '      <li class="list-group-item">' +
            '           <a ng-click="handleResultSelect(result)">' +
            '           <div ng-repeat="propSearchProperty in propSearchProperties">' +
            '               <span ng-if="propSearchProperty.label">{{propSearchProperty.label | translate}}: </span>' +
            '               <span ng-if="!propSearchProperty.label">{{propSearchProperty.name | translate}}: </span>' +
            '               <span>{{result[propSearchProperty.name]}}</span>' +
            '           </div>' +
            '           </a>' +
            '      </li>' +
            '   </ul>' +
            '</div>' +
            '<div ng-hide="propResults.length || propLoading">{{\'No results found\' | translate}}</div>',
        };
    }
);
